import {Box, Button, HStack, IconButton, Spinner} from '@chakra-ui/react';
import {LogOut} from 'lucide-react';
import {useAuth} from '../auth/useAuth';
import {UserAvatar} from './UserAvatar';

export function LoginPanel() {
    const {profile, isSignedIn, isAuthenticating, needsReauth, login, reauthenticate, logout} = useAuth();

    if (isAuthenticating) {
        return <HStack className="login-panel" gap={3} color="white">
            <Spinner size="sm"/>
            <Box>Bejelentkezés...</Box>
        </HStack>;
    }

    return <div className="login-panel">
        {isSignedIn && profile ?
            <HStack gap={3}>
                <UserAvatar size="sm" name={profile.name} src={profile.picture} colorPalette="green"/>
                <Box display={{base: 'none', sm: 'inline'}} maxW="180px" truncate>{profile.email}</Box>
                {needsReauth &&
                    <Button colorPalette="orange" size="sm" onClick={reauthenticate} title="A munkameneted lejárt">
                        Folytatás
                    </Button>
                }
                <IconButton
                    colorPalette="blue"
                    aria-label="Kijelentkezés"
                    title="Kijelentkezés"
                    size="sm"
                    variant="solid"
                    color="white"
                    _hover={{bg: 'blue.600'}}
                    onClick={logout}
                >
                    <LogOut size={20}/>
                </IconButton>
            </HStack>
            :
            <Button colorPalette="blue" onClick={login}>
                Bejelentkezés
            </Button>
        }
    </div>;
}
